module.exports = __webpack_public_path__ + "img/form-a11y-5.dc617262.png";